export default __webpack_public_path__ + "static/media/LoginGraphics-01-01.224ccc1a.png";